import React, { Fragment } from 'react';

import config from 'client/shared/config';
import { NavLink } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

// @inject('documentStore')
export default class FAQS
extends React.Component {
    render () {

        const lipsum = `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
        `
        const dummyFAQs = [
            {
                type: 'FAN_FAQ',
                title: 'How do I subscribe to an artist?',
                content: lipsum,
                orderIndex: 0
            },
            {
                type: 'FAN_FAQ',
                title: 'What is Muzado Insider?',
                content: lipsum,
                orderIndex: 1
            },
            {
                type: 'FAN_FAQ',
                title: 'Is there a section for singular genres?',
                content: lipsum,
                orderIndex: 2
            },
        ]

        const content = dummyFAQs.filter(f=>f.type === 'FAN_FAQ').sort((a,b) => b.orderIndex - a.orderIndex);
        return (
            <Fragment>
                <div style={{padding: '2vw'}}>
                    <div className="section-title" style={{paddingLeft: '1vw'}}>Frequently Asked Questions</div>
                    <ol className="margin-top-3" style={{listStyleType: 'none'}}>
                        {
                            content.map(c => {
                                return (
                                    <li className="margin-bottom-2 margin-top-2" key={`faq${c.orderIndex}`}>
                                        <div className="section-title mini">{c.title}</div>
                                        <p>{c.content}</p>
                                    </li>
                                )
                            })
                        }
                    </ol>
                </div>
            </Fragment>
        )
    }    
}